function parseGcsDateToMs(date: string): number | null {
  // Expected: yyyymmddThhmmssZ (e.g., 20250131T142530Z)
  if (!/^\d{8}T\d{6}Z$/.test(date)) return null;
  const year = Number(date.slice(0, 4));
  const month = Number(date.slice(4, 6)) - 1; // 0-based in JS
  const day = Number(date.slice(6, 8));
  const hour = Number(date.slice(9, 11));
  const minute = Number(date.slice(11, 13));
  const second = Number(date.slice(13, 15));
  const ms = Date.UTC(year, month, day, hour, minute, second);
  return Number.isNaN(ms) ? null : ms;
}
export function parseGcsExpiryMs(url: string): number | null {
  try {
    const u = new URL(url);
    const expiresSec = u.searchParams.get('X-Goog-Expires'); // seconds
    const dateStr = u.searchParams.get('X-Goog-Date'); // yyyymmddThhmmssZ
    if (!expiresSec || !dateStr) return null;
    const issuedMs = parseGcsDateToMs(dateStr);
    if (issuedMs === null) return null;
    const expiresMs = parseInt(expiresSec, 10) * 1000;
    return issuedMs + expiresMs;
  } catch {
    return null;
  }
}